import seoConfig from './seo.json';

const ROBOTS_INDEX = 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1';
const ROBOTS_NOINDEX = 'noindex, follow';

// '/qa/posts/' -> '/qa/posts', giữ nguyên '/'
const normalizePath = (pathname) => {
  if (!pathname || pathname === '/') return '/';
  return pathname.replace(/\/+$/, '') || '/';
};

// So khớp pattern dạng '/qa/posts/:id' hoặc '/auth/*'
const matchPath = (pattern, pathname) => {
  const patternParts = pattern.split('/').filter(Boolean);
  const pathParts = pathname.split('/').filter(Boolean);
  for (let i = 0; i < patternParts.length; i++) {
    const part = patternParts[i];
    if (part === '*') return true;
    if (i >= pathParts.length) return false;
    if (part.startsWith(':')) continue;
    if (part !== pathParts[i]) return false;
  }
  return patternParts.length === pathParts.length;
};

export const getRouteSeo = (pathname) => {
  const path = normalizePath(pathname);
  const route = seoConfig.routes.find((r) => matchPath(r.path, path));
  if (!route) {
    return { title: seoConfig.defaultTitle, description: seoConfig.defaultDescription, path };
  }
  return {
    title: route.title,
    ogTitle: route.ogTitle,
    description: route.description || seoConfig.defaultDescription,
    path: route.canonical || path,
    noindex: !!route.noindex
  };
};

// Nội dung dùng chung giữa trang React và HTML tĩnh lúc build (vd. content.faq)
export const getRouteContent = (path) => {
  const route = seoConfig.routes.find((r) => r.path === path);
  return (route && route.content) || {};
};

// JSON-LD riêng của trang (vd. Article của bài hỏi đáp). Cùng id với thẻ scripts/generate-seo.js chèn lúc build
// nên không bị trùng khi React chạy trên trang đã prerender
export const setJsonLd = (id, data) => {
  if (typeof document === 'undefined') return;
  let el = document.getElementById(id);
  if (!el) {
    el = document.createElement('script');
    el.type = 'application/ld+json';
    el.id = id;
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
};

export const removeJsonLd = (id) => {
  if (typeof document === 'undefined') return;
  const el = document.getElementById(id);
  if (el) el.remove();
};

// Rút gọn HTML/văn bản thành meta description ~160 ký tự
export const toMetaDescription = (text, maxLength = 160) => {
  if (!text) return '';
  const plain = String(text).replace(/<[^>]*>/g, ' ').replace(/&nbsp;/g, ' ').replace(/\s+/g, ' ').trim();
  if (plain.length <= maxLength) return plain;
  const cut = plain.slice(0, maxLength - 1);
  const lastSpace = cut.lastIndexOf(' ');
  return `${lastSpace > 80 ? cut.slice(0, lastSpace) : cut}…`;
};

const upsertMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};

const setCanonical = (href) => {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!href) {
    if (el) el.remove();
    return;
  }
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
};

// Cập nhật title, description, canonical, robots, Open Graph/Twitter cho trang hiện tại
export const applySeo = ({ title, ogTitle, description, path, noindex = false, type = 'website' }) => {
  if (typeof document === 'undefined') return;
  const pageTitle = title || seoConfig.defaultTitle;
  const pageDescription = description || seoConfig.defaultDescription;
  const url = `${seoConfig.siteUrl}${normalizePath(path || window.location.pathname)}`;

  if (document.title !== pageTitle) document.title = pageTitle;
  upsertMeta('name', 'description', pageDescription);
  upsertMeta('name', 'robots', noindex ? ROBOTS_NOINDEX : ROBOTS_INDEX);
  setCanonical(noindex ? null : url);
  upsertMeta('property', 'og:type', type);
  upsertMeta('property', 'og:title', ogTitle || pageTitle);
  upsertMeta('property', 'og:description', pageDescription);
  upsertMeta('property', 'og:url', url);
  upsertMeta('name', 'twitter:title', ogTitle || pageTitle);
  upsertMeta('name', 'twitter:description', pageDescription);
};
